import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-form';

import Popup from '../../Popup';
import { Select } from '../../Form';

const WaitlistPartnerPopup = (props) => {
    const { onCloseClick, selectedPlayer = {}, partnerOptions, onSubmit } = props;
    return (
        <Popup
            className="popup-sm"
            popUpClassName={`${''}`}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                style: {
                    height: 'auto',
                },
            }}
        >
            <Form onSubmit={values => onSubmit(values.partner)}>
                {({ submitForm, values }) => {
                    return (
                        <form onSubmit={submitForm} id="addPartnerForm">
                            <div className="popup-section p24 pt0">
                                <h5>Add partner for {selectedPlayer.firstName} {selectedPlayer.lastName}</h5>
                            </div>
                            <div className="popup-section popup-section-gray p24">
                                <div className={`link-area`}>
                                    <form>
                                        <div className={`form-group mb0`}>
                                            <div className="input-group">
                                                <Select
                                                    label={`Select a partner`}
                                                    emptyOption={`Select a partner`}
                                                    description={`Only players registered in the same division without a partner may be selected. You can also pair partners after registration in the event desk.`}
                                                    id={`partner`}
                                                    field={'partner'}
                                                    options={partnerOptions}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="row mt24">
                                    <div className="col-6">
                                        <button
                                            type="button"
                                            className={`btn btn-default text-uppercase btn-block`}
                                            onClick={onCloseClick}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-6">
                                        <button
                                            type="submit"
                                            className={`btn btn-primary text-uppercase btn-block`}
                                            disabled={!values.partner}
                                        >
                                            Add Partner
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </Popup>
    );
};

WaitlistPartnerPopup.propTypes = {
    selectedPlayer: PropTypes.objectOf({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
    }).isRequired,
    partnerOptions: PropTypes.arrayOf({
        id: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default WaitlistPartnerPopup;
